import React, {useEffect, useState} from 'react';
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import ReactPaginate from "react-paginate";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import CurrencyFormat from "react-currency-format";
import {useDispatch, useSelector} from "react-redux";
import { useLocation} from "react-router-dom";
import { DatePicker } from "zaman";
import Api from "../../../utils/api";
import {BrandAutoComplete, Head, Loading, UserAutocomplete} from "../../../components";
import PeriodAutoComplete from "../../../components/Period";
import RegionAutoComplete from "../../../components/Region";
import {period, region} from "../../../actions";
import ExcelDownloadPins from "./excel";
import {useNavigate} from "react-router";
import queryString from 'query-string';

const OrderProductPins = ( props ) => {


    const location = useLocation();
    const history = useNavigate();
    const  AppState  = useSelector(state => state);

    const dispatch = useDispatch();

    const [searchTime, setSearchTime] = useState("");
    const [loading, setLoading] = useState(false);
    const [entities, setEntities] = useState([]);


    useEffect(() => {
        if (AppState.period.ready !== 'success') {
            dispatch(period());
        }
    }, [AppState.period.ready]);

    useEffect(() => {
        if (AppState.region.ready !== 'success') {
            dispatch(region());
        }
    }, [AppState.region.ready]);


    const handleChangeSearchInput = (event, type = false) => {

        if (!type) {
            _makeQueryStringParams(event.target.name, event.target.value)

        } else {
            const word = event.target.value;
            const name = event.target.name;

            if (searchTime) {
                clearTimeout(searchTime)
            }
            let loop = setTimeout(()=>{

                _makeQueryStringParams(name, word)

            },500);

            setSearchTime(loop);
        }


    }

    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        _makeQueryStringParams(name, value)

    }


    const query = queryString.parse(location.search);

    // state container
    const [params, setParams] = useState({

        page: query.page && !isNaN( query.page) ? parseInt(query.page) : 1,
        limit: query.limit && !isNaN( query.limit) ? parseInt(query.limit) : 100,
        sort_field: query.sort_field ? query.sort_field : 'product_id',
        sort_type: query.sort_type ? query.sort_type : 'desc',

        product_id: query.product_id && !isNaN( query.product_id) ? parseInt(query.product_id) : '',
        title: query.title ? query.title : '',
        code: query.code ? query.code : '',
        brand_id: query.brand_id && !isNaN( query.brand_id) ? parseInt(query.brand_id) : '',

        order_id: query.order_id && !isNaN( query.order_id) ? parseInt(query.order_id) : '',
        month_id: query.month_id && !isNaN( query.month_id) ? parseInt(query.month_id) : '',
        period_id: query.period_id && !isNaN( query.period_id) ? parseInt(query.period_id) : '',
        region_id: query.region_id && !isNaN( query.region_id) ? parseInt(query.region_id) : '',
        from_date: query.from_date ? query.from_date : '',
        to_date: query.to_date ? query.to_date : '',

        user_id: query.user_id && !isNaN( query.user_id) ? parseInt(query.user_id) : '',
        parent_id: query.parent_id && !isNaN( query.parent_id) ? parseInt(query.parent_id) : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
        email: query.email ? query.email : '',

    });


    const handleRequest = () => {

        setLoading(true);

        new Api().get('/products/orderPins', params).then((response) => {
            if (typeof response !== "undefined") {
                setEntities(response);
            }
            setLoading(false);
        })
    }

    useEffect(() => {


        handleRequest();
        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [

        params.sort_field,
        params.sort_type,
        params.page,
        params.limit,

        params.product_id,
        params.title,
        params.code,
        params.brand_id,


        params.period_id,
        params.month_id,
        params.region_id,
        params.from_date,
        params.to_date,

        params.user_id,
        params.parent_id,
        params.name,
        params.username,
        params.national_code,
        params.mobile,
        params.email,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if ((n_params.page) !== (query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'sort_field':
                    if (n_params.sort_field !== query.sort_field) {
                        n_params.sort_field = query.sort_field;
                        n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                    }
                    break;
                case 'limit':
                    if ((n_params.limit) !== (query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;

                case 'order_id':
                    if ((n_params.order_id) !== (query.order_id)) {
                        n_params.order_id = query.order_id;
                    }
                    break;

                case 'from_date':
                    if (n_params.from_date !== query.from_date) {
                        n_params.from_date = query.from_date;
                    }
                    break;
                case 'to_date':
                    if (n_params.to_date !== query.to_date) {
                        n_params.to_date = query.to_date;
                    }
                    break;
                case 'month_id':
                    if ((n_params.month_id) !== (query.month_id)) {
                        n_params.month_id = parseInt(query.month_id);
                    }
                    break;
                case 'period_id':
                    if ((n_params.period_id) !== (query.period_id)) {
                        n_params.period_id = parseInt(query.period_id);
                    }
                    break;
                case 'region_id':
                    if ((n_params.region_id) !== (query.region_id)) {
                        n_params.region_id = parseInt(query.region_id);
                    }
                    break;


                case 'user_id':
                    if ((n_params.user_id) !== (query.user_id)) {
                        n_params.user_id = parseInt(query.user_id);
                    }
                    break;
                case 'parent_id':
                    if ((n_params.parent_id) !== (query.parent_id)) {
                        n_params.parent_id = parseInt(query.parent_id);
                    }
                    break;
                case 'name':
                    if (n_params.name !== query.name) {
                        n_params.name = query.name;
                    }
                    break;
                case 'username':
                    if (n_params.username !== query.username) {
                        n_params.username = query.username;
                    }
                    break;
                case 'national_code':
                    if (n_params.national_code !== query.national_code) {
                        n_params.national_code = query.national_code;
                    }
                    break;
                case 'mobile':
                    if (n_params.mobile !== query.mobile) {
                        n_params.mobile = query.mobile;
                    }
                    break;
                case 'email':
                    if (n_params.email !== query.email) {
                        n_params.email = query.email;
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.sort_field,
        query.sort_type,
        query.page,
        query.limit,

        query.product_id,
        query.title,
        query.code,
        query.brand_id,


        query.period_id,
        query.month_id,
        query.region_id,
        query.from_date,
        query.to_date,

        query.user_id,
        query.parent_id,
        query.name,
        query.username,
        query.national_code,
        query.mobile,
        query.email,
    ]);



    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = parseInt(value);
                break;
            case 'sort_field':
                n_params.sort_field = value;
                n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                break;
            case 'limit':
                n_params.limit = parseInt(value);
                break;

            case 'product_id':
                n_params.product_id = parseInt(value);
                break;
            case 'code':
                n_params.code = value;
                break;
            case 'title':
                n_params.title = value;
                break;
            case 'brand_id':
                n_params.brand_id = parseInt(value);
                break;

            case 'order_id':
                n_params.order_id = value;
                break;
            case 'from_date':
                n_params.from_date = value;
                break;
            case 'to_date':
                n_params.to_date = value;
                break;
            case 'month_id':
                n_params.month_id = parseInt(value);
                break;
            case 'period_id':
                n_params.period_id = parseInt(value);
                break;
            case 'region_id':
                n_params.region_id = parseInt(value);
                break;


            case 'user_id':
                n_params.user_id = parseInt(value);
                break;
            case 'parent_id':
                n_params.parent_id = parseInt(value);
                break;
            case 'name':
                n_params.name = value;
                break;
            case 'username':
                n_params.username = value;
                break;
            case 'national_code':
                n_params.national_code = value;
                break;
            case 'mobile':
                n_params.mobile = value;
                break;
            case 'email':
                n_params.email = value;
                break;
        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;
        url += `&sort_field=${n_params.sort_field}`;
        url += `&sort_type=${n_params.sort_type}`;
        url += `&limit=${n_params.limit}`;

        url += `&product_id=${n_params.product_id}`;
        url += `&title=${n_params.title}`;
        url += `&code=${n_params.code}`;
        url += `&brand_id=${n_params.brand_id}`;

        url += `&order_id=${n_params.order_id}`;
        url += `&month_id=${n_params.month_id}`;
        url += `&period_id=${n_params.period_id}`;
        url += `&region_id=${n_params.region_id}`;
        url += `&from_date=${n_params.from_date}`;
        url += `&to_date=${n_params.to_date}`;

        url += `&user_id=${n_params.user_id}`;
        url += `&parent_id=${n_params.parent_id}`;
        url += `&name=${n_params.name}`;
        url += `&username=${n_params.username}`;
        url += `&national_code=${n_params.national_code}`;
        url += `&mobile=${n_params.mobile}`;
        url += `&email=${n_params.email}`;


        history(`/product/pins/${url}`);

    };


    const pageCount = Math.ceil(parseInt(entities.total) / parseInt(entities.per_page));

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'گزارش گیری محصولات', 'description': 'سرچ براساس فیلدهای مختلف' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="شناسه محصول"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='product_id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="کد انبار"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام محصول"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='title'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <BrandAutoComplete onChange={(value) => handleChangeSearchInputWithAutoComplete('brand_id', value ? value.id : '-1')}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="کد سفارش"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='order_id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <PeriodAutoComplete list={AppState.period.data} onChange={(name, value) => handleChangeSearchInputWithAutoComplete(name, value)}/>
                            <RegionAutoComplete list={AppState.region.data} onChange={(name, value) => handleChangeSearchInputWithAutoComplete(name, value)}/>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete onChange={(value) => handleChangeSearchInputWithAutoComplete('user_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete label={'بالاسری و زیرمجموعه'} onChange={(value) => handleChangeSearchInputWithAutoComplete('parent_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='mobile'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام و نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='name'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام کاربری"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='username'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="کد ملی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='national_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="ایمیل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='email'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}></Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='datepicker-input-container'>
                                    <label>از تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            _makeQueryStringParams('from_date', moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss'))
                                        }}
                                    />

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='datepicker-input-container'>
                                    <label>تا تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            _makeQueryStringParams('to_date', moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss'))
                                        }}
                                    />

                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                            <MenuItem  value="500">500</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page', selectedItem.selected + 1)}
                            forcePage={parseInt(params.page) - 1}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <ExcelDownloadPins object={params} />
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'product_id') } >شناسه محصول&nbsp;{ params.sort_field === 'product_id' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'counter') } >محصول&nbsp;{ params.sort_field === 'counter' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'counter') } >تعداد خرید&nbsp;{ params.sort_field === 'counter' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'price') } >قیمت واقعی&nbsp;{ params.sort_field === 'price' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'off_price') } >قیمت با تخفیف&nbsp;{ params.sort_field === 'off_price' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'tax') } >مالیات&nbsp;{ params.sort_field === 'tax' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {entities.data && entities.data.map((entity, index) => {
                        return(
                            <tr key={index}>
                                <td>{entity.product && entity.product.id}</td>
                                <td>{entity.product && entity.product.title}</td>
                                <td><CurrencyFormat value={entity.counter} displayType={'text'} thousandSeparator={true}  /></td>
                                <td><CurrencyFormat value={entity.price} displayType={'text'} thousandSeparator={true}  /></td>
                                <td><CurrencyFormat value={entity.off_price} displayType={'text'} thousandSeparator={true}  /></td>
                                <td><CurrencyFormat value={entity.tax} displayType={'text'} thousandSeparator={true}  /></td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page', selectedItem.selected + 1)}
                forcePage={parseInt(params.page) - 1}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading />}
        </Container>

    );
}


export default OrderProductPins;
